<template>
  <div class="detail_container">
    <div class="good_pic">
      <img :src="goodDetail.picture" alt="" />
    </div>
    <div class="good_desc">
      <div class="price">
        ￥
        <span class="big">{{ goodDetail.price }}</span>
      </div>
      <div class="name_stock">
        <div class="name">{{ goodDetail.name }}</div>
        <div class="stock">库存{{ goodDetail.stock }}件</div>
      </div>
    </div>
    <div class="good_info">
      <div class="good_info_item">
        <div class="label">
          重量
        </div>
        <div class="value">
          300g/件
        </div>
      </div>
      <div class="good_info_item">
        <div class="label">
          发货
        </div>
        <div class="trag">{{ addressObj[goodDetail.uid] }}</div>
      </div>
      <div class="good_info_item">
        <div class="label">
          运费
        </div>
        <div class="value">{{ deliveryPrice }}元/件</div>
      </div>
    </div>
    <div class="buy_wrapper">
      <div class="buy_num">
        <div class="label">
          购买数量
        </div>
        <div class="num">
          <van-stepper v-model="buyNum" disabled />
        </div>
      </div>
      <div class="btn_wrapper">
        <van-button
          round
          type="info"
          class="buy_btn"
          color="#f93244"
          @click="handleChooseGood"
          >确认礼品</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { goodsListAll, addressLogisticsListByUser, addressList } from '@/api';
import Vue from 'vue';

export default {
  mounted() {
    this.goodDetail = Vue.ls.get('goodInfo');
    this.getDelivery(this.goodDetail.uid);
    this.getAddressObj();
  },
  data() {
    return {
      goodDetail: {},
      buyNum: 1,
      deliveryPrice: '',
      addressObj: {}
    };
  },
  methods: {
    getAddressObj() {
      addressList('').then((res) => {
        let obj = {};
        res.data.forEach((item) => {
          let uid = item.uid;
          let site = item.province + item.city.split('【')[0];
          obj[uid] = site;
        });
        this.addressObj = obj;
      });
    },

    getDelivery(uid) {
      addressLogisticsListByUser(uid).then((res) => {
        this.deliveryPrice = res.data[0].price;
        Vue.ls.set('delivery', res.data[0]);
      });
    },
    handleChooseGood() {
      // this.$store.commit('SET_GOODINFO', this.goodDetail);
      this.$router.push('/buy');
    }
  }
};
</script>

<style lang="less" scoped>
.detail_container {
  background-color: #f7f8fa;

  .good_pic {
    width: 100vw;
    height: 100vw;
    img {
      width: 100%;
    }
  }
  .good_desc {
    background-color: #fff;
    margin-bottom: 3.2vw;
    padding: 4.267vw;
    .price {
      font-family: Avenir;
      font-weight: 500;
      color: #f52907;
      font-size: 5.067vw;
      margin-bottom: 2.133vw;
    }
    .big {
      font-size: 9.067vw;
    }
    .name_stock {
      display: flex;
      justify-content: space-between;

      .name {
        font-size: 4.533vw;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
      }
      .stock {
        font-size: 3.467vw;
        color: rgba(0, 0, 0, 0.45);
      }
    }
  }
  .good_info {
    background-color: #fff;
    .good_info_item {
      padding: 4.267vw 0;
      margin: 0 4.267vw;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      display: flex;
      align-items: center;
      font-size: 3.733vw;
      color: rgba(0, 0, 0, 0.85);
      .label {
        margin-right: 3.2vw;
      }
      .trag {
        padding: 0.533vw 1.067vw;
        font-size: 2.933vw;
        color: #f93244;
        border: 1px solid #f93244;
        border-radius: 0.533vw;
        margin-right: 2.133vw;
      }
    }
  }
  .buy_wrapper {
    margin-bottom: 19.733vw;
    background-color: #fff;
    .buy_num {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 4.8vw 4.267vw 12vw;
      .label {
        font-size: 3.733vw;
        color: rgba(0, 0, 0, 0.85);
      }
      .num {
        font-size: 3.467vw;
        color: rgba(0, 0, 0, 0.45);
      }
    }
    .btn_wrapper {
      display: flex;
      justify-content: center;

      .buy_btn {
        width: 91.467vw;
        height: 11.733vw;
      }
    }
  }
}
</style>
